import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69a6d74e4fab3d0014eb29f1/sebnorge/src/app/machines/components/MachinesInteractive.tsx");
